//include 9

jQuery(function(){

    var privateFunctions = {
        checkSuperior(container){
            var superior_checkbox = container.find(".superior_star input[type='checkbox']");
            var superior_checked = false;
            container.find(".checkbox-wrapper input.is_superior").each(function () {
                if ($(this).is(":checked"))
                    superior_checked = true;
            });
            if (!!superior_checked) {
                superior_checkbox.prop("checked", true);
            }
            else {
                superior_checkbox.prop("checked", false);
            }
        },
        init() {
            $(".stars-checkbox-group").each(function () {
                var $this = $(this);
                if ($this.data("stars-initialized") == "1")
                    return;
                var superior_checkbox = $this.find(".superior_star input[type='checkbox']");
                $this.find(".checkbox-wrapper input[type='checkbox']").on("change", function () {
                    privateFunctions.checkSuperior($this);
                });
                $this.data("stars-initialized", "1");
            });
        }
    };

    privateFunctions.init();

    window.ppComponents.starsGroup = {
        init: function () {
            privateFunctions.init();
        }
    };

});